import { Modal as IOModal } from '@descomplica/foundation-ui-components';
import React from 'react';
import styled, { css } from 'styled-components';

const ModalWrapper = styled.div<{ width?: string; minWidth?: string }>`
  & > div:first-child > div:first-child {
    height: auto;
    padding: 0;
    position: relative;

    ${(props) =>
      props.width
        ? css`
            width: ${props.width};
          `
        : css`
            width: auto;
            min-width: ${props.minWidth ?? '580px'}
            max-width: var(--content-width);
          `}
  }
`;

type Props = Partial<{
  width?: string;
  minWidth?: string;
  children: React.ReactNode;
}>;

export const Modal: React.FC<Props> = (props) => {
  return (
    <ModalWrapper width={props.width}>
      <IOModal>{props.children}</IOModal>
    </ModalWrapper>
  );
};
